export const FIVE_AXIS = 'FIVE_AXIS';
export const TRIVIAL = 'TRIVIAL';
